/*
 * <lp-swipe-match> (sections/lp-swipe-match.liquid): Kartenstapel „Swipe to find your match“.
 * Rechts ziehen = Match (Stempel), links = weiter; Buttons ✕/♥ und Pfeiltasten. Matches landen als Mini-Karten in der
 * Ablage (Add per window.LpCart, „Add all“ für Produkte mit einer Variante, sonst Link aufs Produkt). Ende: Ergebnis-
 * Karte mit „Start over“. Produktdaten aus <script type="application/json" data-items>, Texte aus data-Attributen.
 * Port des Mocks _workbench/home-mock/sections/swipe.js.
 */
(() => {
  if (customElements.get('lp-swipe-match')) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fill = (s, map) => String(s || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));

  class LpSwipeMatch extends HTMLElement {
    connectedCallback() {
      if (this.lpReady) return;
      if (!this.querySelector('[data-deck]')) return;
      this.lpReady = true;
      const root = this;
      const t = this.dataset;
      let items = [];
      try { items = JSON.parse(this.querySelector('[data-items]')?.textContent || '[]'); } catch (err) { items = []; }
      const item = (card) => items[Number(card.dataset.i)] || {};
      const deck = root.querySelector('[data-deck]');
      const cards = [...deck.querySelectorAll('[data-card]')];
      const endCard = deck.querySelector('[data-end]');
      const layers = [...cards, endCard];
      const n = cards.length;
      const noBtn = root.querySelector('[data-no]');
      const yesBtn = root.querySelector('[data-yes]');
      const counter = root.querySelector('[data-counter]');
      const live = root.querySelector('[data-live]');
      const list = root.querySelector('[data-list]');
      const empty = root.querySelector('[data-empty]');
      const countEl = root.querySelector('[data-count]');
      const allBtn = root.querySelector('[data-all]');
      const allN = root.querySelector('[data-all-n]');
      const rail = root.querySelector('[data-rail]');
      const nav = root.querySelector('[data-nav]');
      const prevBtn = root.querySelector('[data-prev]');
      const nextBtn = root.querySelector('[data-next]');
      const endTitle = endCard.querySelector('[data-end-title]');
      const endText = endCard.querySelector('[data-end-text]');
      const endFan = endCard.querySelector('[data-end-fan]');
      const hint = root.querySelector('[data-hint]');
      let index = 0;
      let busy = false;
      let drag = null;
      let raf = 0;
      let hinted = false;
      let matches = [];

      const layout = () => {
        layers.forEach((el, i) => {
          const d = i - index;
          if (d < 0) {
            el.classList.remove('is-top');
            el.setAttribute('aria-hidden', 'true');
            el.inert = true;
            return;
          }
          el.style.setProperty('--d', Math.min(d, 3));
          el.classList.toggle('is-top', d === 0);
          el.classList.toggle('is-hidden', d > 2);
          el.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
          el.inert = d !== 0;
        });
        counter.textContent = index < n ? `${index + 1} / ${n}` : t.allDone;
        noBtn.disabled = yesBtn.disabled = index >= n;
      };

      const hideHint = () => {
        if (hint) hint.classList.remove('is-on');
        cards[index]?.classList.remove('is-hint');
      };

      const pop = (btn) => {
        if (reduce || !btn.animate) return;
        btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(.84)' }, { transform: 'scale(1.1)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'ease-out' });
      };

      // Herzen fliegen aus dem ♥-Button
      const burst = () => {
        if (reduce || !yesBtn.animate) return;
        const svg = yesBtn.querySelector('svg');
        for (let k = 0; k < 7; k++) {
          const s = document.createElement('span');
          s.className = `lp-swipe__spark${k % 2 ? ' is-pink' : ''}`;
          s.setAttribute('aria-hidden', 'true');
          s.append(svg.cloneNode(true));
          yesBtn.append(s);
          const a = ((-90 + (k - 3) * 24) * Math.PI) / 180;
          const dist = 48 + Math.random() * 34;
          s.animate(
            [
              { transform: 'translate(-50%, -50%) scale(.3)', opacity: 1 },
              { transform: `translate(calc(-50% + ${Math.cos(a) * dist}px), calc(-50% + ${Math.sin(a) * dist}px)) scale(${0.6 + Math.random() * 0.5}) rotate(${(k - 3) * 14}deg)`, opacity: 0 },
            ],
            { duration: 650 + k * 40, easing: 'cubic-bezier(.2,.8,.2,1)' },
          ).onfinish = () => s.remove();
        }
      };

      const cartAdd = (items, button, images) => {
        if (!window.LpCart) return;
        Promise.resolve(window.LpCart.add({ body: items.map((m) => ({ id: Number(m.id), quantity: 1 })), button, images })).catch(() => {});
      };

      // Ablage: Pfeile nur, wenn scrollbar; Verlauf am Rand, solange dort noch Karten liegen
      const syncRail = () => {
        const max = list.scrollWidth - list.clientWidth;
        const x = Math.abs(list.scrollLeft);
        const can = matches.length > 0 && max > 2;
        nav.hidden = !can;
        prevBtn.disabled = x <= 2;
        nextBtn.disabled = x >= max - 2;
        rail.classList.toggle('is-more', can && x < max - 2);
        rail.classList.toggle('is-less', can && x > 2);
      };
      // Seitenweise um ganze Karten blättern
      const page = (dir) => {
        const item = list.firstElementChild;
        if (!item) return;
        const step = item.offsetWidth + parseFloat(getComputedStyle(list).columnGap || 0);
        const per = Math.max(1, Math.floor((list.clientWidth + 1) / step));
        list.scrollBy({ left: dir * per * step, behavior: reduce ? 'auto' : 'smooth' });
      };
      prevBtn.addEventListener('click', () => page(-1));
      nextBtn.addEventListener('click', () => page(1));
      list.addEventListener('scroll', () => requestAnimationFrame(syncRail), { passive: true });
      if (window.ResizeObserver) new ResizeObserver(syncRail).observe(list);

      const refreshTray = () => {
        const singles = matches.filter((m) => m.single);
        countEl.textContent = matches.length;
        root.classList.toggle('has-matches', matches.length > 0);
        empty.hidden = matches.length > 0;
        allBtn.hidden = singles.length < 2;
        allN.textContent = singles.length;
        // Ergebniskarte
        const c = matches.length;
        endTitle.textContent = c ? (c === 1 ? t.endOne : fill(t.endOther, { count: c })) : t.endNone;
        endText.textContent = c ? t.endText : t.endNoneText;
        endFan.replaceChildren(...matches.slice(-3).map((m) => {
          const img = new Image();
          img.src = m.img;
          img.alt = '';
          img.width = img.height = 200;
          return img;
        }));
        syncRail();
      };

      const addMatch = (card) => {
        const m = { ...item(card) };
        matches.push(m);
        const li = document.createElement('li');
        li.className = 'lp-swipe__mini';
        const a = document.createElement('a');
        a.href = m.url;
        a.className = 'lp-swipe__mini-img';
        a.setAttribute('aria-label', m.title);
        const img = new Image();
        img.src = m.img;
        img.alt = '';
        img.width = img.height = 200;
        a.append(img);
        m.el = img;
        const name = Object.assign(document.createElement('span'), { className: 'lp-swipe__mini-name', textContent: m.title });
        const price = Object.assign(document.createElement('span'), { className: 'lp-swipe__mini-price', textContent: m.price });
        let btn;
        if (m.single) {
          btn = Object.assign(document.createElement('button'), { type: 'button', className: 'lp-swipe__add', textContent: t.add });
          btn.setAttribute('aria-label', fill(t.addLabel, { title: m.title }));
          btn.addEventListener('click', () => cartAdd([m], btn, [img]));
        } else {
          btn = Object.assign(document.createElement('a'), { href: m.url, className: 'lp-swipe__add lp-swipe__add--link', textContent: t.options });
          btn.setAttribute('aria-label', fill(t.optionsLabel, { title: m.title }));
        }
        li.append(a, name, price, btn);
        // Neuester Match vorne, Ablage an den Anfang
        list.prepend(li);
        list.scrollTo({ left: 0, behavior: reduce || !list.scrollLeft ? 'auto' : 'smooth' });
        refreshTray();
      };

      const threshold = () => Math.min(120, deck.offsetWidth * 0.3);

      const decide = (dir, d) => {
        if (busy || index >= n) return;
        busy = true;
        hideHint();
        const card = cards[index];
        const dy = d ? d.dy * 0.25 : 0;
        card.style.setProperty('--yes', dir > 0 ? 1 : 0);
        card.style.setProperty('--no', dir > 0 ? 0 : 1);
        card.classList.add('is-leaving');
        card.style.transition = reduce ? 'none' : 'transform .5s cubic-bezier(.3,.6,.35,1), opacity .5s cubic-bezier(.7,0,1,1)';
        const out = root.offsetWidth * 0.6 + card.offsetWidth;
        requestAnimationFrame(() => {
          card.style.transform = `translate3d(${dir * out}px, ${dy + 70}px, 0) rotate(${dir * 28}deg)`;
          card.style.opacity = '0';
        });
        deck.style.setProperty('--lift', 1);
        live.textContent = fill(dir > 0 ? t.matched : t.skipped, { title: item(card).title });
        if (dir > 0) { addMatch(card); burst(); }
        setTimeout(() => {
          index += 1;
          layout();
          deck.style.setProperty('--lift', 0);
          busy = false;
          if (index >= n && [noBtn, yesBtn, deck].includes(document.activeElement)) endCard.querySelector('[data-restart]').focus({ preventScroll: true });
        }, reduce ? 0 : 230);
        setTimeout(() => card.classList.add('is-out'), reduce ? 0 : 520);
      };

      const springBack = () => {
        const card = cards[index];
        card.style.transition = reduce ? 'none' : 'transform .6s cubic-bezier(.34,1.56,.64,1)';
        card.style.transform = '';
        card.style.setProperty('--yes', 0);
        card.style.setProperty('--no', 0);
        deck.style.setProperty('--lift', 0);
        setTimeout(() => { card.style.transition = ''; }, 620);
      };

      const act = (dir) => {
        if (busy || index >= n) return;
        pop(dir > 0 ? yesBtn : noBtn);
        decide(dir, null);
      };

      // Geste: Pointer Events; vertikal bleibt beim Browser (touch-action: pan-y)
      const paint = () => {
        raf = 0;
        if (!drag) return;
        const card = cards[index];
        const p = Math.max(-1, Math.min(1, drag.dx / threshold()));
        card.style.transform = `translate3d(${drag.dx}px, ${drag.dy * 0.25}px, 0) rotate(${drag.dx * 0.06}deg)`;
        card.style.setProperty('--yes', Math.max(0, p));
        card.style.setProperty('--no', Math.max(0, -p));
        deck.style.setProperty('--lift', Math.abs(p) * 0.6);
      };

      deck.addEventListener('pointerdown', (e) => {
        const card = cards[index];
        if (busy || !card || !card.contains(e.target) || (e.pointerType === 'mouse' && e.button !== 0)) return;
        drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, dx: 0, dy: 0, on: false, lx: e.clientX, lt: e.timeStamp, vx: 0 };
      });

      deck.addEventListener('pointermove', (e) => {
        if (!drag || e.pointerId !== drag.id) return;
        const dx = e.clientX - drag.x0;
        const dy = e.clientY - drag.y0;
        if (!drag.on) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
          drag.on = true;
          cards[index].style.transition = '';
          try { cards[index].setPointerCapture(e.pointerId); } catch (err) { /* egal */ }
          root.classList.add('is-dragging');
          hideHint();
        }
        const dt = e.timeStamp - drag.lt;
        if (dt > 0) {
          drag.vx = 0.7 * ((e.clientX - drag.lx) / dt) + 0.3 * drag.vx;
          drag.lx = e.clientX;
          drag.lt = e.timeStamp;
        }
        drag.dx = dx;
        drag.dy = dy;
        if (!raf) raf = requestAnimationFrame(paint);
      });

      const end = (e) => {
        if (!drag || e.pointerId !== drag.id) return;
        const d = drag;
        drag = null;
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        if (!d.on) return;
        root.classList.remove('is-dragging');
        const card = cards[index];
        card.dataset.dragged = '1';
        setTimeout(() => { delete card.dataset.dragged; }, 80);
        const flick = Math.abs(d.vx) > 0.55 && Math.sign(d.vx) === Math.sign(d.dx) && Math.abs(d.dx) > 24;
        if (e.type !== 'pointercancel' && (Math.abs(d.dx) > threshold() || flick)) decide(d.dx > 0 ? 1 : -1, d);
        else springBack();
      };
      deck.addEventListener('pointerup', end);
      deck.addEventListener('pointercancel', end);
      // Nach dem Ziehen keinen Klick auf „Details“ auslösen
      deck.addEventListener('click', (e) => {
        const c = e.target.closest('[data-card]');
        if (c && c.dataset.dragged) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      deck.addEventListener('dragstart', (e) => e.preventDefault());

      noBtn.addEventListener('click', () => act(-1));
      yesBtn.addEventListener('click', () => act(1));
      root.addEventListener('keydown', (e) => {
        if (e.altKey || e.metaKey || e.ctrlKey || e.target.closest('[data-tray]')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); act(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); act(1); }
      });

      allBtn.addEventListener('click', () => {
        const singles = matches.filter((m) => m.single);
        if (singles.length) cartAdd(singles, allBtn, singles.map((m) => m.el));
      });

      // Karten austeilen (Einstieg und „Start over“)
      const deal = (then) => {
        if (reduce) { then?.(); return; }
        root.classList.add('is-dealing');
        root.classList.remove('is-dealt');
        void deck.offsetWidth;
        requestAnimationFrame(() => {
          root.classList.add('is-dealt');
          setTimeout(() => { root.classList.remove('is-dealing', 'is-dealt'); then?.(); }, 900);
        });
      };

      const nudge = () => {
        if (hinted || reduce || index !== 0 || drag) return;
        hinted = true;
        cards[0].classList.add('is-hint');
        hint?.classList.add('is-on');
        setTimeout(hideHint, 3200);
      };

      endCard.querySelector('[data-restart]').addEventListener('click', () => {
        index = 0;
        matches = [];
        list.replaceChildren();
        cards.forEach((c) => {
          c.classList.remove('is-out', 'is-leaving');
          c.style.transition = 'none';
          c.style.transform = '';
          c.style.opacity = '';
          c.style.setProperty('--yes', 0);
          c.style.setProperty('--no', 0);
        });
        refreshTray();
        layout();
        void deck.offsetWidth;
        cards.forEach((c) => { c.style.transition = ''; });
        deal();
        deck.focus({ preventScroll: true });
      });

      layout();
      refreshTray();

      if (!reduce) root.classList.add('is-dealing');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          root.classList.toggle('is-live', en.isIntersecting);
          if (en.isIntersecting && en.intersectionRatio >= 0.3 && !root.dataset.dealt) {
            root.dataset.dealt = '1';
            deal(() => setTimeout(nudge, 250));
          }
        });
      }, { threshold: [0, 0.3] });
      io.observe(deck);
    }
  }

  customElements.define('lp-swipe-match', LpSwipeMatch);
})();
